import { SiteCoverage, YearCoverage } from '@shared/api/types';
import Text from '@shared/components/content/text';
import { cn } from '@shared/lib/utils';
import { useMemo } from 'react';
import { Card, CardContent } from '../ui/card';
import { DataCoverageBars } from './components/data-coverage-bars';
import { DataCoverageStatus } from './components/data-coverage-status';

interface DataCoverageCardProps {
  yearName: string;
  monthLabels: string[];
  data: SiteCoverage;
  className?: string;
}

export default function DataCoverageCard({
  data,
  yearName,
  monthLabels,
  className,
}: DataCoverageCardProps) {
  const { name: siteName, years } = data;
  const yearData = useMemo(() => {
    const yearData = years.find((y) => y.name === yearName) as YearCoverage;
    return yearData;
  }, [years, yearName]);

  const isNoSite = siteName === 'No site';

  // Only display "No site" option if it has some data
  if (isNoSite && !yearData.hasData && yearData.months.every((m) => !m.hasData))
    return null;

  return (
    <Card className={cn('p-0', className)}>
      <CardContent className="p-4">
        <div className="mb-4 flex items-center justify-between">
          <Text
            className={cn('text-lg font-semibold', {
              'text-gray-500': isNoSite,
            })}
          >
            {siteName}
          </Text>
          <DataCoverageStatus data={yearData} />
        </div>
        <DataCoverageBars
          siteName={siteName}
          yearData={yearData}
          monthLabels={monthLabels}
        />
      </CardContent>
    </Card>
  );
}
